var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',_vm._g(_vm._b({staticClass:"modal-confirm"},'BaseModal',_vm.attributes,false),_vm.$listeners),[(_vm.title)?_c('BaseTitle',_vm._b({},'BaseTitle',_vm.title,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }